// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__3Smzc","label":"Section_label__2cNBr","contentWrap":"Section_contentWrap__1qhkY","footer":"Section_footer__1St1W","footerInner":"Section_footerInner__8uwxH"};